const pad = n => String(n).padStart(2, '0')
const lastDay = (year, month1) => new Date(year, month1, 0).getDate()

// Returns { from, to, prevFrom, prevTo, currentKey, prevKey } as 'YYYY-MM-DD' strings or null
const getPeriodDateRange = (period, referenceDate = new Date()) => {
  if (!period) return { from: null, to: null, prevFrom: null, prevTo: null, currentKey: null, prevKey: null }

  if (period === 'currentMonth') {
    const year = referenceDate.getFullYear()
    const month = referenceDate.getMonth() + 1
    const prevYear = month === 1 ? year - 1 : year
    const prevMonth = month === 1 ? 12 : month - 1

    return {
      from: `${year}-${pad(month)}-01`,
      to: `${year}-${pad(month)}-${lastDay(year, month)}`,
      prevFrom: `${prevYear}-${pad(prevMonth)}-01`,
      prevTo: `${prevYear}-${pad(prevMonth)}-${lastDay(prevYear, prevMonth)}`,
      currentKey: `${year}-${pad(month)}`,
      prevKey: `${prevYear}-${pad(prevMonth)}`,
    }
  }

  if (period === 'currentYear') {
    const year = referenceDate.getFullYear()
    const prevYear = year - 1
    return {
      from: `${year}-01-01`,
      to: `${year}-12-31`,
      prevFrom: `${prevYear}-01-01`,
      prevTo: `${prevYear}-12-31`,
      currentKey: `${year}`,
      prevKey: `${prevYear}`,
    }
  }

  return { from: null, to: null, prevFrom: null, prevTo: null, currentKey: null, prevKey: null }
}

export default getPeriodDateRange
